module.exports = __webpack_public_path__ + "img/caas3m-m@2.1ee2d501.webp";